import { render, staticRenderFns } from "./PalletTeaser.vue?vue&type=template&id=e33e819a&scoped=true&"
import script from "./PalletTeaser.vue?vue&type=script&lang=js&"
export * from "./PalletTeaser.vue?vue&type=script&lang=js&"
import style0 from "./PalletTeaser.vue?vue&type=style&index=0&id=e33e819a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33e819a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e33e819a')) {
      api.createRecord('e33e819a', component.options)
    } else {
      api.reload('e33e819a', component.options)
    }
    module.hot.accept("./PalletTeaser.vue?vue&type=template&id=e33e819a&scoped=true&", function () {
      api.rerender('e33e819a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/element/PalletTeaser.vue"
export default component.exports